import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { isEmpty } from "lodash";

const filterString = filters => {
  return filters.join("&");
};

export const getMessages = ({ churchId, filters }) => {
  if (isEmpty(filters)) {
    return axios.get(`/churches/${churchId}/messages`);
  }

  return axios.get(`/churches/${churchId}/messages?${filterString(filters)}`);
};

export const useMessages = ({ churchId, filters, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["messages", churchId, filters],
    queryFn: () => getMessages({ churchId, filters })
  });
};
